import React from 'react';
import s from '../menu/Menu.module.css';
import Item from '../menu/Item';
import Nav from '../Nav/Nav';
import set_img from '../../img/set.png'
import grill_img from '../../img/sushi_grill.png'
import dragons_img from '../../img/dragon.jpg'
import kalifornia_img from '../../img/sushi_kalifornia.png'
import philadelphia_img from '../../img/philadelphia.png'
import tempura_img from '../../img/tempura.png'
import sheff_img from '../../img/sheff.png'


const Sushi = (props) => {
    return (
        <div className={s.menu}>
            <Nav link='/' name='Сушi'/>
            <main className={s.main}>
                <Item link='/sets' name='Сети' img={set_img}/>
                <Item link='/sushishef' name='Суші від шефа' img={sheff_img}/>
                <Item link='/hot' name='Запечені суші' img={grill_img}/>
                <Item link='/dragons' name='Дракони' img={dragons_img}/>
                <Item link='/philadelphia' name='Філадельфії' img={philadelphia_img}/>
                <Item link='/california' name='Каліфорнії' img={kalifornia_img}/>
                <Item link='/tampura' name='Темпури' img={tempura_img}/>
            </main>
        </div>
    )
}

export default Sushi;